/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-undef */
import {
    APIUserRole,
    Integration as HIntegration,
    IntegrationEnv as HIntegrationEnv,
} from "humboldt";
import * as queryString from "query-string";
import { Dispatch } from "redux";
import { OAUTH_APP_CONFIG, URL_AFTER_PROFILE_SELECTED, DEAKO_URL_AFTER_PROFILE_SELECTED } from "../constants";
import { getHumboldt } from "../stores/index";
import { AppAction, TypeKeys } from "./actionTypes";
import { Integration, IntegrationEnv } from "./Integration";
import { getItem } from "../auth/utils/localStorage";

export async function getProfileListByUsername(dispatch: Dispatch<AppAction>, authSub: string) {
    dispatch({ type: TypeKeys.LOAD_PROFILE_LIST });

    let profiles: any[] = [];
    let searchError = false;
    try {
        const indexHumboldt = getHumboldt();
        const result = await indexHumboldt.forProfilesList().getProfilesList();
        profiles = Object.values(result.profiles).map((p) => {
            const membership = p.memberships.find((m) => m.sub === authSub);
            if (membership !== undefined && membership.role === APIUserRole.Admin) {
                return p;
            }
            return undefined; // this is dumb, but compiler warns about this not being explicit
        }).filter((l) => l !== undefined).sort((a, b) => a?.name.localeCompare(b?.name || "") || 0);
    } catch (e) {
        searchError = true;
    }

    dispatch({
        type: TypeKeys.RECEIVE_PROFILE_LIST,
        profileList: profiles,
        searchError,
    });
}

function convIntegration2Humboldt(integration: Integration): HIntegration {
    switch (integration) {
        case Integration.ALEXA:
            return HIntegration.ALEXA;
        case Integration.GOOGLE_ASSISTANT:
            return HIntegration.GOOGLE_ASSISTANT;
        case Integration.SMART_THINGS:
            return HIntegration.SMART_THINGS;
        case Integration.SMART_THINGS_SCHEMA:
            return HIntegration.SMART_THINGS;
        case Integration.ALARM_DOT_COM:
            return HIntegration.ALARM_DOT_COM;
        default:
            throw new Error(`Could not convert ${integration}`);
    }
}

function convEnv2Humboldt(env: IntegrationEnv): HIntegrationEnv {
    switch (env) {
        case IntegrationEnv.PROD:
            return HIntegrationEnv.PROD;
        case IntegrationEnv.BETA:
            return HIntegrationEnv.BETA;
        case IntegrationEnv.DEV:
            return HIntegrationEnv.DEV;
        default:
            throw new Error(`Could not convert ${env}`);
    }
}

export async function selectProfile(
    dispatch: Dispatch<AppAction>,
    integration: Integration,
    env: IntegrationEnv,
    profileId: string,
) {
    dispatch({ type: TypeKeys.USER_SELECTED_PROFILE_ID, profileId });

    const queryParams = queryString.parse(window.location.search);
    const mergedParams = {
        ...OAUTH_APP_CONFIG.DEFAULTS,
        ...queryParams,
        ...OAUTH_APP_CONFIG[integration],
    };

    const humboldt = getHumboldt();
    await humboldt.forUser().setProfileFor3rdPartyIntegration(
        convIntegration2Humboldt(integration),
        convEnv2Humboldt(env),
        profileId,
    );

    if ( integration === Integration.ALEXA ||
        integration === Integration.ALARM_DOT_COM ||
        integration === Integration.GOOGLE_ASSISTANT) {
        try {
            // Get access token from storage
            const accessToken = getItem('accessToken');
            
            if (!accessToken) {
                throw new Error('No access token available for authorization');
            }

            // Call the authorize endpoint
            const authorizeUrl = new URL(DEAKO_URL_AFTER_PROFILE_SELECTED, window.location.origin);
            Object.keys(mergedParams).forEach(key => {
                const value = (mergedParams as any)[key];
                if (value !== undefined && value !== null) {
                    authorizeUrl.searchParams.set(key, String(value));
                }
            });

            const response = await fetch(authorizeUrl.toString(), {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`Authorization failed: ${response.status} ${response.statusText}`);
            }

            const result = await response.json();
            
            if (result.success && result.redirect) {
                window.location.href = result.redirect;
            } else {
                throw new Error(result.message || 'Authorization failed');
            }
        } catch (error) {
            console.error('Alexa authorization error:', error);
            // Inform user to try again instead of fallback redirect
            alert('Authorization failed. Please try again.');
        }
    }else{
        const encodedParams: string = queryString.stringify(mergedParams);
        window.location.href = URL_AFTER_PROFILE_SELECTED + encodedParams;
    }
}
